export default __webpack_public_path__ + "static/desk-402f047aa468c243b9d8bef6e7621d41.jpg";